/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { Coupon, CouponFromJSON, CouponFromJSONTyped, CouponToJSON } from './Coupon'

/**
 *
 * @export
 * @interface GetOrganizationPaymentPromotionCodeResponseData
 */
export interface GetOrganizationPaymentPromotionCodeResponseData {
  /**
   *
   * @type {Coupon}
   * @memberof GetOrganizationPaymentPromotionCodeResponseData
   */
  coupon: Coupon
}

export function GetOrganizationPaymentPromotionCodeResponseDataFromJSON(
  json: any
): GetOrganizationPaymentPromotionCodeResponseData {
  return GetOrganizationPaymentPromotionCodeResponseDataFromJSONTyped(json, false)
}

export function GetOrganizationPaymentPromotionCodeResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOrganizationPaymentPromotionCodeResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    coupon: CouponFromJSON(json['coupon'])
  }
}

export function GetOrganizationPaymentPromotionCodeResponseDataToJSON(
  value?: GetOrganizationPaymentPromotionCodeResponseData | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    coupon: CouponToJSON(value.coupon)
  }
}
